<template>
    <MainLayout>
		<div class="container">
            <div class="box">
                <b-row>
					<b-col>
						<h2 class="inline-heading">{{ $t('global.importReservations') }}</h2>
					</b-col>
                    <b-overlay :show="loading" no-wrap rounded></b-overlay>
                    <b-col class="col-md-6">
                        
                        <b-form-group class="d-flex justify-content-end">
                            <b-dropdown id="dropdown-1" :text="$t('global.downloadFormat')" class="m-md-2" variant="success">
                                <b-dropdown-item :href="downloadFormatURL" target="_blank"> <md-icon icon="download"/> {{ $t('global.downloadFormatClean') }}</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item :href="downloadFormatWithExample" target="_blank"><md-icon icon="download"/> {{ $t('global.downloadFormatExample') }} </b-dropdown-item>
                            </b-dropdown>
                        </b-form-group>
					</b-col>
				</b-row>

                <hr/>

                <b-row>
                    <b-form-group :label="$t('global.file')+':'" class="col-md-12">
                        <input type="file" id="file" ref="file" @change="handleFileUpload()"/>
                    </b-form-group>
                    <b-form-group :label="$t('global.dateFormat')+':'" class="col-md-3">
                        <b-form-select v-model="dateFormat" :id="dateFormat" :options="dateFormats"></b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('global.timeFormat')+':'" class="col-md-3">
                        <b-form-select v-model="timeFormat" :id="timeFormat" :options="timeFormats"></b-form-select>
                    </b-form-group>
                    <b-form-group  class="col-md-3 mt-4">
                            <b-form-checkbox switch size="" v-model="usePreviousInfo" >{{ $t("bookings.usePreviousMap") }} <b-badge variant="primary">Beta</b-badge></b-form-checkbox>
                    </b-form-group>
                    <b-form-group class="pt-2 col-md-3">
                        <b-button variant="dark" class="mt-3" @click="submitFile()"><md-icon icon="library_add"/> {{ $t('global.validateInformation') }}</b-button>
                    </b-form-group>
                </b-row>

                <!-- Show error list -->
                <label class="text-danger" v-if="corrections">{{ $t('global.errorsFound') }}</label>
                <ul v-if="message != ''">
                    <li>{{ message }}</li>
                </ul>

                <!-- Table view -->
                 <b-table v-if="errors.length" striped hover small bordered responsive :items="errors" ref="table"
                    show-empty :empty-text="$t('global.ajaxTable.noRecordsFound')">
                    <!-- A custom formatted column -->
                    <template #cell(errores)="data">
                         <ul>
                            <li v-for="(error, index) in data.value" :key="index">
                                <small>{{ error }}</small>
                            </li>
                        </ul>
                    </template>
					<template #cell(input)="data">
                         <ul>
                            <li v-for="(valueError, index) in data.value" :key="index">
                                <b class="text-danger">{{ valueError }}</b>
                            </li>
                        </ul>
                    </template>
                </b-table>

                <!-- End error list -->
			</div>

            <br>
			<div class="box">
				<section id="success" v-if="bookingsCreated.length > 0">
					<b-button variant="outline-primary" size="lg" @click="reload()">
						<md-icon icon="arrow_back"></md-icon> Continuar Importando Reservas
					</b-button>
					<b-alert show variant="success" dismissible class="text-center mt-2">
						<b>Se crearón correctamente las reservas</b>
					</b-alert>

					<b-table striped hover small bordered responsive :items="bookingsCreated" class="text-nowrap borderless mt-3" ref="table-reservations-created"
						show-empty empty-text="No se encontraron datos" :tbody-tr-class="rowClass">
						<template #cell(scReservationId)="data">
							<b-button @click="resView({id:null,reservationId:data.item.scReservationId})" variant="outline-success">
								<span>Ver reservación</span>
							</b-button>
						</template>
					</b-table>
				</section>
				<section v-else>
					<div v-if="mapping">
                        <label>{{ $t('global.selectOption') }}</label>
                        
                        <b-tabs content-class="mt-3">
							<!--------TAB MODULE PLACES------->
                            <b-tab>
                                <template slot="title">
                                    <span>
                                        Pickups & Dropoffs
                                        <b-badge variant="danger" v-if="placesMissingMap>0">{{ placesMissingMap }}</b-badge>
                                        <b-badge variant="success" v-else>OK</b-badge>
                                    </span>
                                </template>
                                <b-card no-body>
                                    <b-tabs pills card vertical v-model="selectedTabPlaces" >

										<b-tab active>
											<template slot="title">
												<h5><md-icon icon="where_to_vote"/><b>{{ importResult.data.placesFound.length }}</b></h5>
											</template>
											<div class="text-center">
												<span v-if="qtyAirportsDiscovered>0"> <md-icon icon="flight"></md-icon>{{ qtyAirportsDiscovered }}</span>
												<span v-else class="text-danger"> <md-icon icon="flight" ></md-icon>{{ qtyAirportsDiscovered }}</span>
											</div>

                                            <b-list-group style="height:350px; overflow-y: scroll;">
                                                <b-list-group-item v-for="(placeDiscovered,_index) in importResult.data.placesFound" :key="_index">
													<b-button @click="movePlaceFoundToMapped(_index)" variant="outline-danger"  :title="$t('global.moveToPendingToMap')"><md-icon icon="edit_location_alt" class="text-red hover:text-white"></md-icon> </b-button>
                                                    {{ placeDiscovered.queryMatched }}:
                                                    <a href="#" @click="showPlace(placeDiscovered.ref)" class="ml-2">
														<md-icon icon="flight" v-if="placeDiscovered.iA"></md-icon>
														<md-icon icon="location_on" v-else></md-icon>
														{{ placeDiscovered.name }}
													</a>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </b-tab>

                                        <b-tab v-if="places.length>0">
											<template slot="title">
												<h5>
													<span class="mr-1"><md-icon icon="wrong_location" /><b>{{ places.length }}</b></span>
													<small>
														<sup>
															<b-badge variant="danger" v-if="placesMissingMap>0">{{ placesMissingMap }}</b-badge>
															<b-badge variant="success" v-else>OK</b-badge>
														</sup>
													</small>
												</h5>
											</template>
											<section style="max-height: 500px; min-height: 350px; overflow-y: scroll; overflow-x: hidden;" >
												<b-row class="p-2">
													<b-col cols="12">
														<b-alert show class="mb-1 text-center">{{ $t("global.placesNotDiscovered") }}</b-alert>
													</b-col>
												</b-row>
												<b-row v-if="placemapping " class="p-2">
													<div class="col-md-6 justify-content-between" v-for="(place, index) in places" :key="place">
														<search-places class="w-100" @getData="setData" :label="$t('global.search')" :place="place" v-model="responses[index].model"></search-places>
													</div>
												</b-row>
											</section>
                                        </b-tab>

                                    </b-tabs>
                                </b-card>
                            </b-tab>
							<!--------END TAB MODULE PLACES------->



							<!--------TAB MODULE SERVICE TYPES------->
                            <b-tab>
                                <template slot="title">
                                    <span>
										{{ $t('global.typesServices') }}
                                        <b-badge variant="danger" v-if="servicesTypeMissingMap>0">{{ servicesTypeMissingMap }}</b-badge>
                                        <b-badge variant="success" v-else>OK</b-badge>
                                    </span>
                                </template>
                                <div>
                                    <ServiceTypesMap :serviceTypes="importResult.data.service_types_list"></ServiceTypesMap>
                                </div>
                            </b-tab>
							<!--------END TAB MODULE SERVICE TYPES------->

                            <!--------TAB MODULE SALES CHANNEL------->
                            <b-tab>
                                <template slot="title">
                                    <span>
										{{ $t('global.salesChannels') }}
                                        <b-badge variant="danger" v-if="salesChannelMissingMap>0">{{ salesChannelMissingMap }}</b-badge>
                                        <b-badge variant="success" v-else>OK</b-badge>
                                    </span>
                                </template>
                                <div class="">
                                    <SalesChannelsMap :salesChannels="importResult.data.sales_channels_list"></SalesChannelsMap>
                                </div>
                            </b-tab>
							<!--------END TAB MODULE SALES CHANNEL------->
                        </b-tabs>
						<hr>

					</div>
                    <section>
                        <b-row>
                            <b-col>
                                <h4>Data:</h4>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md class="mb-2">
                                <div class="mr-4">
                                    <span>{{rowsMessage}}</span>
                                    <b-form-select size="sm" class="ml-2" id="perPageSelector" v-model="perPage" :options="perPageOptions" @change="submitFile(false)"></b-form-select>
                                </div>
                            </b-col>
                            <b-col md class="text-right">
                                <b-row no-gutters>
                                    <b-col >
                                        <b-pagination v-model="currentPage" align="right" :total-rows="totalRows" :per-page="perPage" @input="submitFile(false)"/>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>

                        <b-row>
                           <b-col>
                                <b-table striped hover small bordered responsive :items="items" class="text-nowrap borderless" ref="table"
                                show-empty :empty-text="$t('global.ajaxTable.noRecordsFound')" :tbody-tr-class="rowClass">
                                </b-table>
                           </b-col>
                        </b-row>
                    </section>



					<div class="d-flex justify-content-end  mb-4 fixed-bottom " style="margin-right: 6%;" v-if="canInsertBookings"  >
						<b-button variant="success" v-if="mapping" class="mr-2" @click="submitFileMap()" size="lg" :disabled="loading" ><md-icon icon="library_add" class="__shake"/> 
                            <span v-if="loading">{{ $t("global.createBookings") }}</span>
                            <span v-else>{{ $t("global.createBookings") }}</span>
                        </b-button>
					</div>
				</section>
			</div>
        </div>
        <FormReservation
            ref="single"
            :model-id.sync="resSelected.modalModelId"
            :show.sync="resSelected.show"
            @onCopyRes="copyCurrentRes"
            operated-by="supplier"
		/>

		<section>
			<b-modal id="modal-lg" size="lg" ref="modalMaps">
				<div>
					<iframe
					width="750"
					height="600"
					style="border:0"
					allowfullscreen
					referrerpolicy="no-referrer-when-downgrade"
					:src="gmapsSource">
					</iframe>
				</div>

			</b-modal>
		</section>
    </MainLayout>
</template>

<script>
    import MainLayout from '../layout/MainLayout.vue'
    import SearchPlaces from './SearchPlaces.vue'
    import FormReservation from './Single.vue'
    import SalesChannelsMap from './massive-import/MapSalesChannels.vue'
    import ServiceTypesMap from './massive-import/MapServiceTypes.vue'

    export default { components: { MainLayout,  SearchPlaces, FormReservation,SalesChannelsMap,ServiceTypesMap },
        props: {
            showSelectAll: {
				type : Boolean,
				required: false,
				default : false
			},
            model: {
                type: Array,
                required: false,
            },
            valueType: [String, Object]
        },
        data() {
            return {
                file: '',
                importResult: '',
                showSingleModal: false,
                loading:false,
                items:[],
                dateFormat: 'Y-m-d',
                dateFormats: [
                    {value:'Y-m-d', text:"2024-09-13 (YYYY-mm-dd)"},
                    {value:'d-m-Y', text:"13-09-2024 (dd-mm-YYYY)"},
                    {value:'m-d-Y', text:"09-13-2024 (mm-dd-YYYY)"},
                    {value:'Y/m/d', text:"2024/09/13 (YYYY/mm/dd)"},
                    {value:'d/m/Y', text:"13/09/2024 (dd/mm/YYYY)"},
                    {value:'m/d/Y', text:"09/13/2024 (mm/dd/YYYY)"},

                    {value:'Y-n-j', text:"2024-9-5 (YYYY-m-d)"},
                    {value:'j-n-d', text:"5-9-2024 (d-m-YYYY)"},
                    {value:'n-j-Y', text:"9-5-2024 (m-d-YYYY)"},
                    {value:'Y/n/j', text:"2024/9/5 (YYYY/m/d)"},
                    {value:'j/n/Y', text:"5/9/2024 (d/m/YYYY)"},
                    {value:'n/j/Y', text:"9/5/2024 (m/d/YYYY)"},
                ],
                timeFormat: 'H:i',
                timeFormats: [
                    {value: 'H:i', text: '08:00 24hrs'},
                    {value: 'G:i', text: '8:00 24hrs'},

                    {value: 'h:i a', text: '08:00 am'},
                    {value: 'g:i a', text: '8:00 am'},
                    {value: 'h:i A', text: '08:00 AM'},
                    {value: 'g:i A', text: '8:00 AM'},
                ],
                perPage:50,
				currentPage:1,
				totalRows:0,
                perPageOptions:[
					{value:10,text:10},
					{value:50,text:50},
					{value:100,text:100},
					{value:200,text:200},
					{value:500,text:500},
				],
				selectAll: false,
                places: [],
                selected:null,
                mapping:false,
                placemapping: false,
                mappedPlaces: [],
                responses: [],
                errors: [],
                corrections: false,
                message: '',
                resSelected: {
					modalModelId: -1,
					tsSelectedId: -1,
					copyResId: -1,
					formTypeWork:"",
					show:false
				},
				bookingsCreated:[],
				gmapsSource:null,
                usePreviousInfo:true,
                selectedTabPlaces:0
            }
        },
        computed:{
			offset(){ return (this.currentPage-1)*this.perPage },
			rowsFrom(){ return this.offset+1},
			rowsTo(){ return Math.min(this.offset+this.perPage,this.totalRows) },
			rowsMessage() {
				return this.$t("global.ajaxTable.showingNRecords", {
					from: this.rowsFrom,
					to: this.rowsTo,
					total: this.totalRows
				});
			},
            downloadFormatURL() {
                return `${process.env.VUE_APP_API_URL}/downloadFormat`
            },
            downloadFormatWithExample() {
                return `${process.env.VUE_APP_API_URL}/downloadFormatExample`
            },
            servicesTypeMissingMap(){
                let count = 0;
                try{
                    this.importResult.data.service_types_list.forEach((serviceType)=>{
                        if(!serviceType.matchedSelected.id>0) count++;
                    })
                }catch(err){
                    return 0;
                }
                return count;
            },
            salesChannelMissingMap(){
                let count = 0;
                try{
                    this.importResult.data.sales_channels_list.forEach((saleChannel)=>{
                        if(!saleChannel.matchedSelected.id>0) count++;
                    })
                }catch(err){
                    return 0;
                }
                return count;
            },
            placesMissingMap(){
                return (this.places.length-this.mappedPlaces.length)
            },
			qtyAirportsDiscovered(){
				let airports =[]
				this.importResult.data.placesFound.forEach((place)=>{
					if(place.iA) airports.push(place.ref);
				})
				const uniqueAirports = new Set(airports);
				return uniqueAirports.size;
			},
            canInsertBookings(){
                if(!this.mapping) return false;
                return (this.placesMissingMap==0 && this.salesChannelMissingMap==0 && this.servicesTypeMissingMap==0 )
            }

        },
        methods:{
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
            },
            submitFile(reloadMapping = true) {
                this.loading     = true
                this.corrections = false
                this.message     = false
                this.errors      = []
                this.bookingsCreated = []

                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('dateFormat', this.dateFormat)
                formData.append('timeFormat', this.timeFormat)
                formData.append('usePreviousInfo',this.usePreviousInfo)
                formData.append('limit', this.perPage)
                formData.append('offset', this.offset)
                this.$root.api.post(`/importxls`,
                    formData, {
                        timeout: 1000 * 60 * 2, //2 minutes
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then((res) => {

                    this.importResult = res.data;
                    this.loading      = false

                    //Error reading file
                    if (this.importResult.error) {
                        this.mapping     = false
                        this.corrections = true
                        this.message     = this.importResult.message
                        this.items       = []
                        this.totalRows   = 0
                        this.$root.showAlert('Error: ' + this.importResult.message, {variant:'danger'})
                        console.log('error: ' + this.importResult.message)
                        return false
                    }

                    this.errors    = this.importResult.data.errors
                    this.selected  = 1
                    this.items     = res.data.data.bookings
                    this.totalRows = res.data.data.totalBookings

                    //Not reload inputs
                    if (!reloadMapping) return false
                    if (Object.keys(this.importResult.data.errors).length > 0) {
                        this.mapping     = false
                        this.corrections = true
                        this.$root.showAlert(this.$t('global.errorsFoundAlert'), {variant:'warning'})
                        return false
                    }

                    try{
                        if(this.importResult.data.sales_channels_list.length>0 || this.importResult.data.service_types_list.length>0 ){
                            this.mapping = true
                        }
                    }catch(err){
                        console.error(err);
                    }

                    
                   
					this.mappedPlaces=[];
					this.places =[];
					this.responses = [];
					setTimeout(() => {
						this.places = res.data.data.places
						this.placemapping = true
						if (Object.keys(this.places).length > 0) {
							this.places.map(() => {
								this.responses.push({model: null})
							})
						}
					}, 0);


                }).catch(error => {
                    this.$root.handleRequestError(error)
                    this.loading = false
                });
            },
            submitFileMap() {
                this.loading = true

                let formData = new FormData()
                formData.append('file', this.file)
                formData.append('mappedPlaces', JSON.stringify(this.mappedPlaces))
                formData.append('placesFound', JSON.stringify(this.importResult.data.placesFound))
                formData.append('mappedServices', JSON.stringify(this.mappedServices))
                formData.append('dateFormat', this.dateFormat)
                formData.append('timeFormat', this.timeFormat)
                formData.append('confirmation', true)
                formData.append('salesChannelsList', JSON.stringify(this.importResult.data.sales_channels_list))
                formData.append('serviceTypesList', JSON.stringify(this.importResult.data.service_types_list))
                formData.append('usePreviousInfo',this.usePreviousInfo)
                this.$root.api.post(`/importxls`, formData).then((res) => {

                    this.corrections = false
                    this.message     = false
                    this.loading     = false

                    if (res.data.error) {
                        this.corrections = true
                        this.message     = res.data.message
                        this.$root.showAlert(res.data.message, {variant:'danger'})
                        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                        console.log(res.data.message)
                        return false
                    }

                    //Reload page
                    this.$root.showAlert(this.$t('global.successfullyRegistered'))
                    this.reload()
                    this.bookingsCreated = res.data.data.bookings

                }).catch(error => {
                    this.$root.handleRequestError(error)
                    this.loading = false
                })
            },
            updateTable(){
				this.$refs.table.refresh()
			},
            setData(data) {

                //Quitamos si existe ya uno previamente y fue actualizado
                this.mappedPlaces.map((match, index) => {
                    if (match.index == data.index) {
                        this.mappedPlaces.splice(index, 1)
                    }
                })
                this.mappedPlaces.push(data)
            },
            rowClass(item) {
                //Indicamos donde se encuentra el error dentro de los datos
                for(let error of this.errors) {
                    if (item.indice === error.indice) return 'table-danger'
                }
            },
            reload() {
                this.mapping   = false
				this.mappedPlaces=[];
                this.items     = []
                this.totalRows = 0
                this.$refs.file.value = null
                this.responses = [];
				this.bookingsCreated=[]
            },
            resView(item) {
                this.resSelected.tsSelectedId = item.id;
                this.resSelected.copyResId    = -1;
                this.resSelected.modalModelId = item.reservationId;
                this.resSelected.show         = true;

                //configuramos el estado de formulario formService
                this.resSelected.formTypeWork = "viewForm";
            },
            copyCurrentRes(){
				const aux = this.resSelected.modalModelId
				this.resSelected.modalModelId = -1
				this.$refs.single.copyFromId(aux)
			},
			showPlace(ref){
				this.$root.api.get(`/places/${ref}/geodetails`).then((res)=>{
					try{
						this.gmapsSource = res.data.embededSource+"&key="+process.env.VUE_APP_GOOGLE_MAPS_API_KEY
					}catch(err){
						this.gmapsSource = res.data.embededSource;
					}

					this.$refs["modalMaps"].show();
				})

			},
			movePlaceFoundToMapped(indexPlaces){
				const found = this.importResult.data.placesFound.find((value, index) => {
					return (index== indexPlaces)
				});
				if(!found) this.$root.showAlert('Error selecting the place', {variant: 'danger'})
				this.$bvModal
					.msgBoxConfirm(this.$t("global.confirmMovePlaceToMap")+" "+found.queryMatched+"?", {
						title: " ",
						size: "sm",
						buttonSize: "sm",
						okVariant: "success",
						okTitle: this.$t("global.yes"),
						cancelTitle: "No",
						footerClass: "p-2",
						hideHeaderClose: false,
						centered: true
					})
					.then(value => {
						if (value === true) {
							if(found){
								this.importResult.data.placesFound.splice(indexPlaces,1);
								this.places.push(found.queryMatched);
								this.responses.push({model: null}) //create the node when the map will be stored
                                this.selectedTabPlaces=1
							}
						}
					}).catch(err => {
						console.log(err);
						// An error occurred
					});


			}
        },
        mounted(){}
    }
</script>

<style >
	/*.active {
		color: cornflowerblue;
	}*/
	#perPageSelector{
		width: 80px
	}
</style>
